export default [
	{ "text": "使用分析", "icon": "el-icon-s-claim", "path": "/ReportView" },
	{ "text": "日志查询", "icon": "el-icon-s-claim", "path": "/TestReport" },
]